import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function MentionsLegales() {
  return (
    <div className="bg-white min-h-screen py-24 px-6 md:px-12">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-sm text-slate-600 hover:text-spi-blue">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>
        <h1 className="mt-8 font-display text-4xl text-spi-blue font-bold">Mentions légales</h1>

        <div className="mt-10 text-slate-700 space-y-6">
          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">1. Éditeur du site</h2>
            <p>
              Le présent site est édité par <strong>Swiss Premium Insurance</strong>,
              service privé et indépendant d'optimisation et d'intermédiation en assurance.
              <br />
              Email&nbsp;: contact@sp-insurance.ch
              <br />
              Téléphone&nbsp;: +41 22 559 86 84
              <br />
              Adresse&nbsp;: Pl. de Cornavin 14, 1201 Genève, Suisse
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">2. Statut & indépendance</h2>
            <p>
              <strong>Swiss Premium Insurance est un service privé et indépendant
              d'optimisation et d'intermédiation en assurance</strong>, sans lien
              d'affiliation avec les administrations cantonales ou l'assurance-maladie
              obligatoire.
            </p>
            <p>
              Notre activité porte sur l'accompagnement administratif personnalisé,
              l'analyse comparative et l'intermédiation en assurances. Les informations
              et l'aide à la vérification des droits aux subsides sont fournies
              <strong> à titre indicatif</strong>. La demande officielle peut être
              déposée de manière autonome et gratuite auprès de votre organisme
              cantonal compétent.
            </p>
            <p>
              Inscrit au registre fédéral des intermédiaires d'assurance tenu par
              la FINMA. Activité régie par la Loi sur la surveillance des assurances
              (LSA) et la Loi sur le contrat d'assurance (LCA).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">3. Hébergement</h2>
            <p>
              Hébergé sur infrastructure cloud sécurisée localisée dans l'Union européenne / Suisse.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">4. Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus du site (textes, images, logos) est protégé par le droit
              d'auteur. Toute reproduction sans autorisation préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">5. Avertissement simulateur</h2>
            <p>
              Le simulateur de subsides présent sur ce site fournit une estimation
              <strong> indicative non contractuelle</strong>, basée sur des barèmes
              publics simplifiés. Seul l'organisme cantonal compétent est habilité
              à confirmer officiellement un droit au subside.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">6. Loi applicable</h2>
            <p>
              Le présent site est régi par le droit suisse. Tout litige relèvera des
              tribunaux compétents du canton de Genève.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
